var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7219 3.21479L12.0007 9.93305L5.28101 3.21479C5.00193 2.93571 4.53583 2.93571 4.24799 3.22355L3.22374 4.24488C2.92275 4.54733 2.93297 4.99882 3.21497 5.28082L9.9347 11.9991L3.21497 18.7203C2.9359 18.9994 2.9359 19.4655 3.22374 19.7533L4.24799 20.7775C4.54752 21.0771 4.99901 21.0683 5.28101 20.7863L12.0007 14.0651L18.7219 20.7863C18.9995 21.0654 19.4671 21.0654 19.7549 20.7775L20.7792 19.7533C21.0787 19.4538 21.07 19.0023 20.788 18.7203L14.0682 11.9991L20.788 5.28082C21.0656 5.00175 21.067 4.53272 20.7792 4.24488L19.7549 3.22355C19.6044 3.07306 19.4174 3 19.2319 3C19.0434 3 18.8607 3.07306 18.7219 3.21479Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
